// Controls
import { Button, DialogTitle, Tooltip, mergeClasses } from "@fluentui/react-components";
import { Dismiss } from "../icons";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { useDialogTitleWithDismissStyles } from "./DialogTitleWithDismiss.styles";
// Utilities
import * as React from "react";
import { customizeStyles } from "../utilities/StyleUtilities";
/**
 * Generic dialog title component with dismiss button functionality
 */ export const DialogTitleWithDismiss = (props)=>{
    const { title, onDismiss, customStyles, className } = props;
    const baseStyles = useDialogTitleWithDismissStyles();
    const styles = customizeStyles(baseStyles, customStyles);
    return /*#__PURE__*/ React.createElement("div", {
        className: mergeClasses(styles.titleContainer, className)
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        className: styles.dialogTitle
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        content: title,
        relationship: "description"
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.titleText
    }, title))), /*#__PURE__*/ React.createElement(Tooltip, {
        content: Strings.SharedComponents_CloseButtonText,
        relationship: "label"
    }, /*#__PURE__*/ React.createElement(Button, {
        appearance: "subtle",
        "aria-label": Strings.SharedComponents_CloseButtonText,
        icon: /*#__PURE__*/ React.createElement(Dismiss, null),
        onClick: onDismiss,
        className: styles.dismissButton,
        "data-testid": "dialog-dismiss-button"
    })));
};
